import { NewLicenseModel } from '@/modules/LicensesPage/models/LicensesModel'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { PaymentsRequestModel } from '../models/PaymentsModel'
import PaymentsService from '../PaymentsService'

export const getPaymentsThunk = createAsyncThunk(
  'payments/getPaymentsThunk',
  async (id: string, { rejectWithValue }) => {
    try {
      return await PaymentsService.getPayments(id)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const newLicenseThunk = createAsyncThunk(
  'payments/newLicenseThunk',
  async (data: NewLicenseModel, { rejectWithValue }) => {
    try {
      return await PaymentsService.newLicense(data)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const renewalsLicenseThunk = createAsyncThunk(
  'payments/renewalsLicenseThunk',
  async (data: PaymentsRequestModel, { rejectWithValue }) => {
    try {
      return await PaymentsService.renewalsLicense(data)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const paymentsSlice = createSlice({
  name: 'payments',
  initialState: null,
  reducers: {},
})

export const { actions, reducer } = paymentsSlice
